/**
 * @generated SignedSource<<9e25d111a8e0a79843944a741c6b6095>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ActivateFeaturesPLUTemplateMutation$variables = Record<PropertyKey, never>;
export type ActivateFeaturesPLUTemplateMutation$data = {
  readonly activatePLU: {
    readonly pluCategories: ReadonlyArray<{
      readonly id: string;
    }>;
  } | null;
};
export type ActivateFeaturesPLUTemplateMutation = {
  response: ActivateFeaturesPLUTemplateMutation$data;
  variables: ActivateFeaturesPLUTemplateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ActivatePLUPayload",
    "kind": "LinkedField",
    "name": "activatePLU",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PLUCategory",
        "kind": "LinkedField",
        "name": "pluCategories",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ActivateFeaturesPLUTemplateMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ActivateFeaturesPLUTemplateMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "74aa00550e16c4813f8213619c0da36d",
    "id": null,
    "metadata": {},
    "name": "ActivateFeaturesPLUTemplateMutation",
    "operationKind": "mutation",
    "text": "mutation ActivateFeaturesPLUTemplateMutation {\n  activatePLU {\n    pluCategories {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "52c28f1a0334620484bedff3afcde20d";

export default node;
